import { Outlet, createFileRoute } from "@tanstack/react-router";
import { AuthGuard } from "../components/AuthGuard";
import { isAuthenticated, refreshTokens, startLogin } from "../lib/auth";

/**
 * アプリ本体（要認証）のレイアウトルート。
 *
 * - VITE_STAGE === "local" では認証チェックをバイパス
 * - それ以外: トークン未保持なら refresh 試行、失敗なら Cognito にリダイレクト
 * - クライアントサイドの追加ガードとして AuthGuard も併用（直接 URL アクセス対策）
 */
export const Route = createFileRoute("/_app")({
  beforeLoad: async () => {
    if (import.meta.env.VITE_STAGE === "local") {
      return;
    }
    if (!isAuthenticated()) {
      const restored = await refreshTokens();
      if (!restored) {
        await startLogin();
      }
    }
  },
  component: AppLayout,
});

function AppLayout() {
  return (
    <AuthGuard>
      <Outlet />
    </AuthGuard>
  );
}
